import { render, staticRenderFns } from "./TournamentPrizePool.vue?vue&type=template&id=0371515d&scoped=true"
import script from "./TournamentPrizePool.vue?vue&type=script&lang=js"
export * from "./TournamentPrizePool.vue?vue&type=script&lang=js"
import style0 from "./TournamentPrizePool.vue?vue&type=style&index=0&id=0371515d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0371515d",
  null
  
)

export default component.exports